/* eslint-disable @nx/enforce-module-boundaries */
import { EnvironmentProviders, Provider } from '@angular/core';

import { IInitialData } from '@frontend/oxygen/core';
import { FreeBetsBadgeService, VanillaApiService } from '@frontend/oxygen/core-vanillainit';
import { ApiServiceFactory, ClientConfigProductName, MENU_COUNTERS_PROVIDER, ProductService } from '@frontend/vanilla/core';

declare global {
    interface Window {
        cmsInitPromise: Promise<IInitialData>;
    }
}

export function apiServiceFactory(service: ApiServiceFactory, productService: ProductService) {
    return service.create(VanillaApiService, {
        product: 'ozone',
        area: 'coralsports',
        forwardProductApiRequestHeader: productService.getMetadata(ClientConfigProductName.OZONE).isEnabled,
    });
}

export function provideCoralSportsFeatures(): (Provider | EnvironmentProviders)[] {
    return ngServerMode
        ? []
        : [
              { provide: 'CMS_CONFIG', useValue: (window as any)['cmsInitPromise'] },
              { provide: MENU_COUNTERS_PROVIDER, useExisting: FreeBetsBadgeService, multi: true },
              { provide: VanillaApiService, deps: [ApiServiceFactory, ProductService], useFactory: apiServiceFactory },
          ];
}
